// extracted by mini-css-extract-plugin
export var activeDot = "_7n-c";
export var buttonContainer = "_7n-9";
export var channelButton = "_7n-a";
export var clickable = "_7n-d";
export var content = "_7n-0";
export var contentFull = "_7n-2";
export var contentThird = "_7n-1";
export var contentWrapper = "_7n-7";
export var description = "_7n-5";
export var heightShort = "_7n-f";
export var image = "_7n-3";
export var imageContainer = "_7n-4";
export var selectButton = "_7n-e";
export var spinnerContainer = "_7n-b";
export var titleContent = "_7n-8";
export var titleWrapper = "_7n-6";